export default (props) => (
  <svg {...props} viewBox="0 0 20 20" aria-hidden="true" focusable="false">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M5.866 13.258c-1.799 0-3.245-1.514-3.066-3.309.155-1.561 1.597-2.706 3.206-2.706h2.101c.494 0 .893-.391.893-.871a.882.882 0 00-.893-.872H5.866C2.972 5.5.659 7.98 1.04 10.876 1.356 13.27 3.566 15 6.043 15h2.064c.494 0 .893-.39.893-.871a.882.882 0 00-.893-.871H5.866zM11.894 5.5a.884.884 0 00-.894.871c0 .482.401.871.894.871h2.242c1.8 0 3.243 1.516 3.063 3.31-.157 1.56-1.597 2.705-3.208 2.705h-2.097a.884.884 0 00-.894.87c0 .482.401.873.894.873h2.064c2.476 0 4.686-1.731 5-4.124C19.34 7.979 17.03 5.5 14.137 5.5h-2.242z"
        fill="currentColor"
        fillRule="nonzero"
      />
      <rect
        fill="currentColor"
        fillRule="nonzero"
        x="7"
        y="9.5"
        width="6"
        height="1.5"
        rx=".75"
      />
    </g>
  </svg>
);
